import throttle from 'lodash/throttle';
// import { compose, createStore, applyMiddleware } from 'redux';
// import { configureStore } from "@reduxjs/toolkit";
import { configureStore } from '@reduxjs/toolkit';
// Or from '@reduxjs/toolkit/query/react'
import { setupListeners } from '@reduxjs/toolkit/query';
import { loadState, saveState } from './localStorage';

import rootReducer from './reducers/reducer';
import { apiSlice } from './services/apiSlice';
import { authApi } from './services/authApi';

// const composeEnhancers = (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

// let store;
// export const initStore = ({} = {}) => {
//   // const persistedState = loadState(); // get initial state from local storage
//   store = createStore(
//     {
//       ...reducer,
//       [patientApi.reducerPath]: patientApi.reducer,
//       [providerApi.reducerPath]: providerApi.reducer,
//     },
//     {}, // persistedState,
//     composeEnhancers(applyMiddleware(
//       // add middleware here
//       middleware: (getDefaultMiddleware) =>
//         getDefaultMiddleware().concat(pokemonApi.middleware),
//     ))
//   );
//   return store;
//   // store.subscribe(throttle(
//   //   () => saveState(store.getState())
//   //   , 2000
//   // )); // save data to local storage
// };

let store;

export const init = ({epicMiddleware = null}) => {
  store = configureStore({
    preloadedState: loadState(), // get initial state from local storage
    reducer: rootReducer,
    middleware: getDefaultMiddleware => (
      getDefaultMiddleware().concat(
        apiSlice.middleware,
        authApi.middleware,
        epicMiddleware
      )
    )
  });
  setupListeners(store.dispatch);
  store.subscribe(throttle(
  () => saveState(store.getState())
  , 2000
)); // save data to local storage
  return store;
};


export const getStore = function getStore() {
  return store;
};
